module.exports = __webpack_public_path__ + "static/hero-image-4@3x-b696bf08650ee3a41a07e8d547d3f633.jpg";